import styled from 'styled-components';
import { InputFull } from '.';

export const InputFullForm = styled(InputFull)`
  margin-bottom: 2rem;
`;
